import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    mainView: viewProfileVisibility => ({
      flex: 1,
      backgroundColor: colors.backgroundMuted, //viewProfileVisibility ? COLORS.black_70 : COLORS.white,
    }),
    headerStyle: {
      padding: 24,
      backgroundColor: colors.surface,
    },
    subHeading: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 16,
    },
    midTabStyle: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 16,
      backgroundColor: colors.surface,
      borderRadius: 8,
      borderWidth: 1,
      flex: 1,
      flexDirection: 'row',
      borderColor: colors.border,
      marginHorizontal: 8,
    },
    bloodSugarCardModule: {
      marginHorizontal: 8,
      flexDirection: 'row',
    },
    buttonContainerStyle: {
      shadowColor: colors.shadow,
      shadowOffset: {
        width: 0,
        height: 30,
      },
      shadowOpacity: 0.2,
      shadowRadius: 30,
      elevation: 5,
    },
    buttonStyle: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      alignItems: 'center',
      margin: 16,
      marginTop: 16,
    },
    allMeasurementsStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    daysSelector: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.surface,
    },
    dayStyle: selected => ({
      paddingHorizontal: 16,
      paddingBottom: 8,
      borderBottomWidth: 2,
      borderBottomColor: selected ? colors.accentStrong : colors.surface,
    }),
    padding16: {
      padding: 16,
    },
    miniCalendar: {
      flexDirection: 'row',
      margin: 16,
    },
    fullFlex: {
      flex: 1,
    },
  });

export default makeStyles;
